// @flow
import { createStore, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";

import rootReducer from "./reducer";

// Added for redux debugging
// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export default initialState =>
    createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(thunkMiddleware)));



// WEBPACK FOOTER //
// ./src/state/index.js